import URLS from "@/constants/url"

export default function prepareCommentsToTable (comments = []) {
  return comments.map(comment => {
    return {
      ...comment,
      username: comment?.user?.username,
      // link: `${URLS.app}/auctions/${comment?.year}-${comment?.make}-${comment?.model}/${comment?.uuid}` // TODO: Move link to .env
      link: `${URLS.app}/auctions/${comment?.carId}` // TODO: Move link to .env
    }
  })
}
